export const JOB_STATUS = [
    { value: 'Indépendant/Freelance', label: 'Indépendant/Freelance' },
    { value: 'Responsable/Manager', label: 'Responsable/Manager' },
    { value: 'Employé', label: 'Employé' },
    { value: 'Autres', label: 'Autres' }
];